export default {"src":"/_next/static/media/homeTopic.ad361811.svg","height":856,"width":1394,"blurWidth":0,"blurHeight":0};